import React, { useState, useEffect } from 'react';

import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { useTranslation } from 'react-i18next';
import UserService from '../../../../Service/UserService';
const $ = window.jQuery;

export default function (props) {
	// NOSONAR
	const updateLangauge = async locale => {
		try {
			const userWithUpdatedLocale = props.currentUser;
			userWithUpdatedLocale.profile.locale = cCodeLCodeMapping[locale];
			await props.setCurrentUser(userWithUpdatedLocale);
			i18n.changeLanguage(cCodeLCodeMapping[locale]);
			$.event.trigger({
				type: 'language-changed',
				language: cCodeLCodeMapping[locale]
			});
			const requestBody = {
				first_name: props.currentUser.profile.first_name,
				last_name: props.currentUser.profile.last_name,
				locale: cCodeLCodeMapping[locale]
			};
			const response = await UserService.updateUserInfo(requestBody);
			if (response.status) {
				const updatedUser = await UserService.updateCurrentUser();
				await props.setCurrentUser(updatedUser);
			}
		} catch (error) {
			console.log(error);
		}
	};
	const changeLangForNonLoggedinUser = locale => {
		i18n.changeLanguage(locale);
		$.event.trigger({
			type: 'language-changed',
			language: cCodeLCodeMapping[locale]
		});
	};
	const profile = props.currentUser ? props.currentUser.profile : {};
	const { i18n } = useTranslation();
	const cCodeLCodeMapping = {
		TL: 'tl',
		CEB: 'ceb',
		US: 'en-US',
		ES: 'es-ES'
	};
	const cCodeLCodeRMapping = {
		tl: 'TL',
		ceb: 'CEB',
		'en-US': 'US',
		'es-ES': 'ES'
	};
	let defaultCountry = cCodeLCodeRMapping[i18n.language] || 'US';
	if (profile && profile.locale) {
		if (i18n.language !== profile.locale) {
			i18n.changeLanguage(profile.locale || 'en-US');
		}
		defaultCountry = cCodeLCodeRMapping[profile.locale] || 'US';
	}
	const languageOptions = [
		{ lang: 'Tl', code: 'TL', flag: '/images/philippines.png' },
		{ lang: 'Ceb', code: 'CEB', flag: '/images/philippines.png' },
		{ lang: 'En', code: 'US', flag: '/images/english.png' },
		{ lang: 'Es', code: 'ES', flag: '/images/spain.png' }
	];

	const [isSmallScreen, setIsSmallScreen] = useState(false);
	const updateScreenSize = () => {
		setIsSmallScreen(window.innerWidth <= 400);
	};
	useEffect(() => {
		updateScreenSize();
		window.addEventListener('resize', updateScreenSize);
		return () => {
			window.removeEventListener('resize', updateScreenSize);
		};
	}, []);

	return (
		// <Select
		//     labelId="language-select"
		//     id="language-select" autoWidth
		//     onChange={(c) => { props.currentUser ? updateLangauge(c.target.value) : changeLangForNonLoggedinUser(cCodeLCodeMapping[c.target.value]); }}
		//     defaultValue={defaultCountry}
		//     value={defaultCountry ? defaultCountry : ""}
		//     disableUnderline={true}
		//     style={{ paddingLeft: '12px' }}
		//     className={'mdl-language-selector ' + (props.fromProfileScreen ? "mdl-language-selector-profile" : "mdl-language-selector-home")}
		// >
		//     {languageOptions.map((lang) => (
		//         <MenuItem key={lang.code} value={lang.code} style={{ paddingLeft: '12px' }}><img src={lang.flag} style={{ width: 20 }} alt=''></img>&nbsp;&nbsp;{isSmallScreen ? '' : lang.lang}</MenuItem>
		//     ))}
		// </Select>
		<Select
			labelId="language-select"
			id="language-select"
			autoWidth
			onChange={c => {
				props.currentUser
					? updateLangauge(c.target.value)
					: changeLangForNonLoggedinUser(cCodeLCodeMapping[c.target.value]);
			}}
			defaultValue={defaultCountry}
			value={defaultCountry ? defaultCountry : ''}
			disableUnderline={true}
			style={{ paddingLeft: '12px' }}
			className={
				'mdl-language-selector ' +
				(props.fromProfileScreen ? 'mdl-language-selector-profile' : 'mdl-language-selector-home') +
				(isSmallScreen ? ' small-screen' : '')
			}>
			{languageOptions.map(lang => (
				<MenuItem
					key={lang.code}
					value={lang.code}
					style={{ paddingLeft: '12px' }}
					disabled={lang.lang !== 'En'}>
					{isSmallScreen && !props.fromProfileScreen ? (
						<>
							<img src={lang.flag} style={{ width: 20 }} alt="" />
							&nbsp;&nbsp;
							{lang.lang !== 'En' && !props.fromProfileScreen ? lang.lang + ' (Coming Soon)' : lang.lang}
						</>
					) : (
						<>
							<img src={lang.flag} style={{ width: 20 }} alt="" />
							&nbsp;&nbsp;
							{lang.lang !== 'En' && props.fromProfileScreen ? lang.lang + ' (Coming Soon)' : lang.lang}
						</>
					)}
				</MenuItem>
			))}
		</Select>
	);
}
